<template>
  <div class="minidiv p-1 m-2">
    <div class="flex-parent text-center p-1">
      
      <div v-for="field, index in fields" :key="index" class="flex-child">
        <slot :name="field" :data="data">
          <div class="p-2 text-left result-col">{{ data[field] }}</div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
//import miniGraph2 from '@/components/miniGraph2'

export default {
  components: {
    //miniGraph2
  },
  props: {
    data : {
      default : () => {},
      type: Object
    },
    fields : {
      default : () => [],
      type : Array
    }
  },
  data() {
    return {
      overallscore: 0
    };
  },
};
</script>

<style scoped>
.minidiv {
  background-color : #fbfbfb;
  overflow:auto;
}

.rins {
  font-size: 0.75rem;
}

.lowscore {
  color: red;
}

.highscore {
  color: #00377b;
}

.totsco {
  color: #00377b;
  font-weight: bolder;
}

.brel {
  text-decoration: none;
  color: black;
}
.result-col{
    font-size: 1rem;
}

.flex-parent {
    display: flex;
    min-width:700px;
    flex-flow: row nowrap;
    overflow:auto
}

.flex-child {
    width: 100%;
    overflow:visible

}
@media screen and (max-width: 999px) {
     .flex-child{
        font-size: 0.75rem
    }
    .link-sol{
        font-size: 0.7rem
      }
}
</style>
